import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Modal = ({
  isOpen,
  hideModal,
  title = "Modal",
  content = "Modal Content",
  width = "sm"
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={hideModal}
      slots={{
        transition: Transition,
      }}
      fullWidth={true}
      maxWidth={width}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          borderBottom: "1px solid #ccc",
          position: "relative",
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={hideModal}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
    </Dialog>
  );
};

export default Modal;
